import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import PhoneInput from 'react-phone-number-input';
import axios from 'axios';

import '../../App.css';
import { Formik, Form, ErrorMessage } from 'formik';
import { EventInitialValues, EventValidations } from './formData/eventValidations';
import { GetFlagCountryCode } from '../../utils';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process?.env;

const EventForm = ({ site, t, siteLogoUrl, visitorTypes, eventId, token, history }) => {
  const handleSubmit = (values, actions) => {
    const payload = {
      name: values?.name || '',
      email: values?.email || '',
      phone: values?.phone || '',
      company: values?.company || '',
      inviteetype: values?.inviteetype || '',
      position: values?.position || '',
      city: values?.city || '',
      state: values?.state || '',
      doorAccess: false,
      id: eventId,
      paymentStatus: false,
      answers: [],
    };
    axios
      .post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/events/registerEventGuest`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      })
      .then((result) => {
        history.push('/register-guest-response');
      })
      .catch((err) => {
        actions.setSubmitting(false);
        toast.error(err?.response?.data?.error?.message || 'Something went wrong!', {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  return (
    <div className="container max-w-xs mx-auto">
      <ToastContainer />
      <Formik initialValues={EventInitialValues()} validationSchema={EventValidations} enableReinitialize={true} onSubmit={handleSubmit}>
        {({ values, handleBlur, handleChange, setFieldValue, handleSubmit, errors, touched, isSubmitting }) => {
          return (
            <Form className={`bg-white px-8 pt-6 pb-8 mb-4`} onSubmit={handleSubmit}>
              <h1 className="text-lg text-black font-bold text-center mt-4">
                {t('WELCOME TO')}
                <br />
                {site?.name || ''}
              </h1>
              <div className="p-2">
                <img className="mx-auto h-24 object-center" src={siteLogoUrl} alt={site.name || ''} />
              </div>
              {/* Entry type Field */}
              <div className="text-lg text-black mb-4">
                What type of Event Participant are you?
                <br />
                <br />
                <label className="block text-sm text-black font-bold mb-2" htmlFor="inviteetype">
                  {t('Participant Type')}
                </label>
                <select
                  name="inviteetype"
                  className={`bg-white shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.inviteetype && touched.inviteetype ? 'border-red-500' : ''
                  }`}
                  value={values.inviteetype || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="inviteetype"
                >
                  <option>{t('Please select Invitee type')}</option>
                  {visitorTypes?.map((v) => (
                    <option key={v?.roleId} data-visitor-type-role-id={v?.roleId} value={v?.name}>
                      {v?.name}
                    </option>
                  ))}
                </select>
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="inviteetype" />
              </div>

              {/* name Field */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="name">
                  {t('Name')}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.name && touched?.name ? 'border-red-500' : ''
                  }`}
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.name || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="name" />
              </div>

              {/* email field */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="email">
                  {t('Email')}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.email && touched?.email ? 'border-red-500' : ''
                  }`}
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.email || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="email" />
              </div>

              {/* company field */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="company">
                  {t('Company')}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.company && touched?.company ? 'border-red-500' : ''
                  }`}
                  id="company"
                  name="company"
                  type="text"
                  placeholder="Company name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.company || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="company" />
              </div>

              {/* phone number field */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="phone">
                  Phone Number
                </label>
                <PhoneInput
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.phone && touched?.phone ? 'border-red-500' : ''
                  }`}
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  onChange={(value) => setFieldValue('phone', value || '')}
                  onBlur={(e) => handleBlur(e || '')}
                  value={values?.phone || ''}
                  international
                  defaultCountry={GetFlagCountryCode(site?.address?.country || '') || 'CA'}
                  limitMaxLength={true}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="phone" />
              </div>

              {/* position */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="position">
                  {'Position'}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.position && touched?.position ? 'border-red-500' : ''
                  }`}
                  id="position"
                  name="position"
                  type="text"
                  placeholder="Position"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.position || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="position" />
              </div>

              {/* city */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="city">
                  {'City'}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.city && touched?.city ? 'border-red-500' : ''
                  }`}
                  id="city"
                  name="city"
                  type="text"
                  placeholder="City"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.city || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="city" />
              </div>

              {/* State */}
              <div className="mb-4">
                <label className="block text-sm text-black font-bold mb-2" htmlFor="state">
                  {'State'}
                </label>
                <input
                  className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors?.state && touched?.state ? 'border-red-500' : ''
                  }`}
                  id="state"
                  name="state"
                  type="text"
                  placeholder="State"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.state || ''}
                />
                <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="state" />
              </div>

              <div style={{ width: '100%' }}>
                <button
                  type="submit"
                  value="Submit"
                  className="bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                  style={{ width: '100%' }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
export default EventForm;
